<template>
    <div class="columns is-centered">
        <div class="column is-half-desktop">
            <div class="field">
                <div class="control has-icons-right">
                    <input v-model="searchModel" type="text" class="input" placeholder="Enter model name">
                    <span class="icon icon-small is-right">
                        <i class="fas fa-search"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            searchModel: {
                get() {
                    return this.$store.search
                },
                set(value) {
                    this.$store.commit('changeSearchValue', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Model/SearchBox.vue